<template>
  <div class="resellers-container1">
    <app-navigation></app-navigation>
    <CookieBanner 
      :force-show="showCookieBanner" 
      @consent-saved="handleConsent" 
      @close="showCookieBanner = false" 
    />
    <main class="partner-main">
      <section class="partner-hero2">
        <div class="partner-hero-video-container">
          <video src="https://vlecadblob.blob.core.windows.net/vlecad-website-mp4/Media/Sequence%2002%20(5).mp4" loop="true" muted="true" autoplay="true" playsinline="true" class="partner-hero-video"></video>
          <div class="partner-hero-overlay2"></div>
        </div>
        <div class="section-content partner-hero-content2">
          <div class="partner-hero-badge2">
            <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m11 17l2 2a1 1 0 1 0 3-3"></path>
                <path d="m14 14l2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"></path>
                <path d="m21 3l1 11h-2M3 3L2 14l6.5 6.5a1 1 0 1 0 3-3M3 4h8"></path>
              </g>
            </svg>
            <span>{{ $t('resellers.hero.badge') }}</span>
          </div>
          <h1 class="partner-hero-title2">
            <span>{{ $t('resellers.hero.titleLine1') }}</span>
            <br />
            <span>{{ $t('resellers.hero.titleLine2') }}</span>
          </h1>
          <p class="partner-hero-subtitle2">{{ $t('resellers.hero.subtitle') }}</p>
          <div class="partner-hero-cta">
            <a href="#partner-apply">
              <div class="btn btn-lg btn-primary">
                <span>{{ $t('resellers.hero.ctaPrimary') }}</span>
              </div>
            </a>
            <a href="#why-partner">
              <div class="btn btn-lg btn-outline">
                <span class="resellers-text104">{{ $t('resellers.hero.ctaSecondary') }}</span>
              </div>
            </a>
          </div>
          <div class="partner-hero-cta">
            <a href="https://korpussoft.com" target="_blank">
              <div class="btn btn-lg btn-outline">
                <span class="resellers-text104">
                  KORPUS site
                </span>
              </div>
            </a>
            <a href="https://autofitsoftware.com" target="_blank">
              <div class="btn btn-lg btn-outline">
                <span class="resellers-text104">
                  AutoFIT site
                </span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section id="why-partner" class="partner-why">
        <div class="section-content">
          <div class="partner-why-header">
            <span class="partner-section-label">{{ $t('resellers.whyPartner.label') }}</span>
            <h2 class="section-title">
              <span>{{ $t('resellers.whyPartner.titleLine1') }}</span>
              <br />
              <span>{{ $t('resellers.whyPartner.titleLine2') }}</span>
            </h2>
            <p class="partner-why-intro">
              <span>{{ $t('resellers.whyPartner.intro') }}</span>
            </p>
          </div>
          <div class="partner-why-grid2">
            <div class="partner-why-card2">
              <div class="partner-why-icon2">
                <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                  </g>
                </svg>
              </div>
              <h3 class="partner-why-title2">{{ $t('resellers.whyPartner.cards.margins.title') }}</h3>
              <p class="partner-why-text">{{ $t('resellers.whyPartner.cards.margins.text') }}</p>
              <ul class="partner-why-list">
                <li><span>{{ $t('resellers.whyPartner.cards.margins.bullets[0]') }}</span></li>
                <li><span>{{ $t('resellers.whyPartner.cards.margins.bullets[1]') }}</span></li>
                <li><span>{{ $t('resellers.whyPartner.cards.margins.bullets[2]') }}</span></li>
              </ul>
            </div>
            <div class="partner-why-card2">
              <div class="partner-why-icon2">
                <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2z"></path>
                    <path d="M21 16v2a4 4 0 0 1-4 4h-5"></path>
                  </g>
                </svg>
              </div>
              <h3 class="partner-why-title2">{{ $t('resellers.whyPartner.cards.support.title') }}</h3>
              <p class="partner-why-text">{{ $t('resellers.whyPartner.cards.support.text') }}</p>
              <ul class="partner-why-list">
                <li><span>{{ $t('resellers.whyPartner.cards.support.bullets[0]') }}</span></li>
                <li><span>{{ $t('resellers.whyPartner.cards.support.bullets[1]') }}</span></li>
                <li><span>{{ $t('resellers.whyPartner.cards.support.bullets[2]') }}</span></li>
              </ul>
            </div>
            <div class="partner-why-card2">
              <div class="partner-why-icon2">
                <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24">
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <h3 class="partner-why-title2">{{ $t('resellers.whyPartner.cards.product.title') }}</h3>
              <p class="partner-why-text">{{ $t('resellers.whyPartner.cards.product.text') }}</p>
              <ul class="partner-why-list">
                <li><span>{{ $t('resellers.whyPartner.cards.product.bullets[0]') }}</span></li>
                <li><span>{{ $t('resellers.whyPartner.cards.product.bullets[1]') }}</span></li>
                <li><span>{{ $t('resellers.whyPartner.cards.product.bullets[2]') }}</span></li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="partner-tiers2">
        <div class="section-content">
          <div class="partner-tiers-header">
            <span class="partner-section-label">{{ $t('resellers.tiers.label') }}</span>
            <h2 class="section-title">{{ $t('resellers.tiers.title') }}</h2>
            <p class="partner-tiers-intro">{{ $t('resellers.tiers.intro') }}</p>
          </div>
          <div class="partner-tiers-grid2">
            <div class="partner-tier-silver partner-tier-card2">
              <div class="partner-tier-badge">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle r="6" cx="12" cy="8"></circle>
                  </g>
                </svg>
                <span>{{ $t('resellers.tiers.silver.title') }}</span>
              </div>
              <div class="partner-tier-price">
                <span class="partner-tier-commission">20%</span>
                <span class="partner-tier-label">{{ $t('resellers.tiers.silver.commissionLabel') }}</span>
              </div>
              <p class="partner-tier-desc">{{ $t('resellers.tiers.silver.description') }}</p>
              <ul class="partner-tier-features2">
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.silver.features[0]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.silver.features[1]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.silver.features[2]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.silver.features[3]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.silver.features[4]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.silver.features[5]') }}</span>
                </li>
              </ul>
              <a href="#partner-apply">
                <div class="btn btn-outline partner-tier-cta">
                  <span>{{ $t('resellers.tiers.silver.cta') }}</span>
                </div>
              </a>
            </div>
            <div class="partner-tier-featured2 partner-tier-card2 partner-tier-gold">
              <div class="partner-tier-featured-badge2">
                <span>{{ $t('resellers.tiers.gold.badge') }}</span>
              </div>
              <div class="partner-tier-badge">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978m7-7.318v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978M18 9h1.5a1 1 0 0 0 0-5H18M4 22h16"></path>
                    <path d="M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm0 0H4.5a1 1 0 0 1 0-5H6"></path>
                  </g>
                </svg>
                <span>{{ $t('resellers.tiers.gold.title') }}</span>
              </div>
              <div class="partner-tier-price">
                <span class="partner-tier-commission">27%</span>
                <span class="partner-tier-label">{{ $t('resellers.tiers.gold.commissionLabel') }}</span>
              </div>
              <p class="partner-tier-desc">{{ $t('resellers.tiers.gold.description') }}</p>
              <ul class="partner-tier-features2">
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>
                    <span class="resellers-text142">{{ $t('resellers.tiers.gold.features[0]') }}</span>
                  </span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.gold.features[1]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.gold.features[2]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.gold.features[3]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.gold.features[4]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.gold.features[5]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.gold.features[6]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.gold.features[7]') }}</span>
                </li>
              </ul>
              <a href="#partner-apply">
                <div class="btn btn-primary partner-tier-cta">
                  <span>{{ $t('resellers.tiers.gold.cta') }}</span>
                </div>
              </a>
            </div>
            <div class="partner-tier-platinum partner-tier-card2">
              <div class="partner-tier-badge">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('resellers.tiers.platinum.title') }}</span>
              </div>
              <div class="partner-tier-price">
                <span class="partner-tier-commission">35%</span>
                <span class="partner-tier-label">{{ $t('resellers.tiers.platinum.commissionLabel') }}</span>
              </div>
              <p class="partner-tier-desc">{{ $t('resellers.tiers.platinum.description') }}</p>
              <ul class="partner-tier-features2">
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>
                    <span class="resellers-text153">{{ $t('resellers.tiers.platinum.features[0]') }}</span>
                  </span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.platinum.features[1]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.platinum.features[2]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.platinum.features[3]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.platinum.features[4]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.platinum.features[5]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.platinum.features[6]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.platinum.features[7]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.tiers.platinum.features[8]') }}</span>
                </li>
              </ul>
              <a href="#partner-apply">
                <div class="btn btn-outline partner-tier-cta">
                  <span>{{ $t('resellers.tiers.platinum.cta') }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section class="partner-profiles">
        <div class="section-content">
          <div class="partner-profiles-layout">
            <div class="partner-profiles-content">
              <span class="partner-section-label">{{ $t('resellers.profiles.label') }}</span>
              <h2 class="section-title">{{ $t('resellers.profiles.title') }}</h2>
              <p class="partner-profiles-text">{{ $t('resellers.profiles.intro') }}</p>
              <div class="partner-profiles-grid">
                <div class="partner-profile-item">
                  <div class="partner-profile-icon">
                    <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                        <circle r="3" cx="12" cy="12"></circle>
                      </g>
                    </svg>
                  </div>
                  <h3 class="partner-profile-title2">{{ $t('resellers.profiles.items.cncDealers.title') }}</h3>
                  <p class="partner-profile-desc2">{{ $t('resellers.profiles.items.cncDealers.text') }}</p>
                </div>
                <div class="partner-profile-item">
                  <div class="partner-profile-icon">
                    <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73zm1 .27V12"></path>
                        <path d="M3.29 7L12 12l8.71-5M7.5 4.27l9 5.15"></path>
                      </g>
                    </svg>
                  </div>
                  <h3 class="partner-profile-title2">{{ $t('resellers.profiles.items.softwareResellers.title') }}</h3>
                  <p class="partner-profile-desc2">{{ $t('resellers.profiles.items.softwareResellers.text') }}</p>
                </div>
                <div class="partner-profile-item">
                  <div class="partner-profile-icon">
                    <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                        <circle r="4" cx="9" cy="7"></circle>
                      </g>
                    </svg>
                  </div>
                  <h3 class="partner-profile-title2">{{ $t('resellers.profiles.items.interiorConsultants.title') }}</h3>
                  <p class="partner-profile-desc2">{{ $t('resellers.profiles.items.interiorConsultants.text') }}</p>
                </div>
                <div class="partner-profile-item">
                  <div class="partner-profile-icon">
                    <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                        <rect x="2" y="6" rx="2" width="20" height="14"></rect>
                      </g>
                    </svg>
                  </div>
                  <h3 class="partner-profile-title2">{{ $t('resellers.profiles.items.technicalDistributors.title') }}</h3>
                  <p class="partner-profile-desc2">{{ $t('resellers.profiles.items.technicalDistributors.text') }}</p>
                </div>
              </div>
            </div>
            <div class="partner-profiles-visual">
              <img alt="Business partnership handshake" src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" class="partner-profiles-image"/>
              <div class="partner-profiles-stat">
                <div class="partner-profiles-stat-number"><span>92%</span></div>
                <div class="partner-profiles-stat-label">
                  <span>{{ $t('resellers.profiles.stat.label') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="partner-process">
        <div class="section-content">
          <div class="partner-process-header">
            <span class="partner-section-label">{{ $t('resellers.process.label') }}</span>
            <h2 class="section-title">{{ $t('resellers.process.title') }}</h2>
            <p class="partner-process-intro">{{ $t('resellers.process.intro') }}</p>
          </div>
          <div class="partner-process-steps">
            <div class="partner-process-step">
              <div class="partner-process-step-number"><span>01</span></div>
              <div class="partner-process-step-content">
                <h3 class="partner-process-step-title">{{ $t('resellers.process.steps.apply.title') }}</h3>
                <p class="partner-process-step-text">{{ $t('resellers.process.steps.apply.text') }}</p>
                <div class="partner-process-step-features">
                  <span>{{ $t('resellers.process.steps.apply.features[0]') }}</span>
                  <span>{{ $t('resellers.process.steps.apply.features[1]') }}</span>
                  <span>{{ $t('resellers.process.steps.apply.features[2]') }}</span>
                </div>
              </div>
              <div class="partner-process-step-visual">
                <svg width="48" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                    <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                  </g>
                </svg>
              </div>
            </div>
            <div class="partner-process-step">
              <div class="partner-process-step-number"><span>02</span></div>
              <div class="partner-process-step-content">
                <h3 class="partner-process-step-title">{{ $t('resellers.process.steps.onboarding.title') }}</h3>
                <p class="partner-process-step-text">{{ $t('resellers.process.steps.onboarding.text') }}</p>
                <div class="partner-process-step-features">
                  <span>{{ $t('resellers.process.steps.onboarding.features[0]') }}</span>
                  <span>{{ $t('resellers.process.steps.onboarding.features[1]') }}</span>
                  <span>{{ $t('resellers.process.steps.onboarding.features[2]') }}</span>
                </div>
              </div>
              <div class="partner-process-step-visual">
                <svg width="48" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 24 24">
                  <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
            </div>
            <div class="partner-process-step">
              <div class="partner-process-step-number"><span>03</span></div>
              <div class="partner-process-step-content">
                <h3 class="partner-process-step-title">{{ $t('resellers.process.steps.sell.title') }}</h3>
                <p class="partner-process-step-text">{{ $t('resellers.process.steps.sell.text') }}</p>
                <div class="partner-process-step-features">
                  <span>{{ $t('resellers.process.steps.sell.features[0]') }}</span>
                  <span>{{ $t('resellers.process.steps.sell.features[1]') }}</span>
                  <span>{{ $t('resellers.process.steps.sell.features[2]') }}</span>
                </div>
              </div>
              <div class="partner-process-step-visual">
                <svg width="48" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
            </div>
            <div class="partner-process-step">
              <div class="partner-process-step-number"><span>04</span></div>
              <div class="partner-process-step-content">
                <h3 class="partner-process-step-title">{{ $t('resellers.process.steps.grow.title') }}</h3>
                <p class="partner-process-step-text">{{ $t('resellers.process.steps.grow.text') }}</p>
                <div class="partner-process-step-features">
                  <span>{{ $t('resellers.process.steps.grow.features[0]') }}</span>
                  <span>{{ $t('resellers.process.steps.grow.features[1]') }}</span>
                  <span>{{ $t('resellers.process.steps.grow.features[2]') }}</span>
                </div>
              </div>
              <div class="partner-process-step-visual">
                <svg width="48" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="partner-apply" class="partner-apply">
        <div class="section-content">
          <div class="partner-apply-layout">
            <div class="partner-apply-info">
              <span class="partner-section-label">{{ $t('resellers.apply.label') }}</span>
              <h2 class="section-title">{{ $t('resellers.apply.title') }}</h2>
              <p class="partner-apply-text">{{ $t('resellers.apply.text') }}</p>
              <div class="partner-apply-benefits">
                <div class="partner-apply-benefit">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.apply.benefits[0]') }}</span>
                </div>
                <div class="partner-apply-benefit">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.apply.benefits[1]') }}</span>
                </div>
                <div class="partner-apply-benefit">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.apply.benefits[2]') }}</span>
                </div>
                <div class="partner-apply-benefit">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('resellers.apply.benefits[3]') }}</span>
                </div>
              </div>
              <div class="partner-apply-image">
                <img alt="Business partnership agreement" src="https://images.pexels.com/photos/327540/pexels-photo-327540.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"/>
              </div>
            </div>
            <div class="partner-apply-form-container">
              <form id="partnerApplicationForm" @submit.prevent="handleSubmit" class="partner-apply-form" novalidate>
                <div class="partner-form-row2">
                  <div class="partner-form-field2">
                    <label for="companyName" class="partner-form-label2">{{ $t('resellers.apply.form.company') }}</label>
                    <input type="text" id="companyName" name="companyName" v-model="form.company" class="partner-form-input2" />
                    <p v-if="errors.company" class="error">{{ $t('resellers.apply.form.error') }}</p>
                    <p v-else class="error"></p>
                  </div>
                </div>
                <div class="partner-form-row2 partner-form-row-2">
                  <div class="partner-form-field2">
                    <label for="contactPerson" class="partner-form-label2">{{ $t('resellers.apply.form.contact') }}</label>
                    <input type="text" id="contactPerson" name="contactPerson" v-model="form.contact" class="partner-form-input2" />
                    <p v-if="errors.contact" class="error">{{ $t('resellers.apply.form.error') }}</p>
                    <p v-else class="error"></p>
                  </div>
                  <div class="partner-form-field2">
                    <label for="email" class="partner-form-label2">{{ $t('resellers.apply.form.email') }}</label>
                    <input type="email" id="email" name="email" v-model="form.email" class="partner-form-input2" />
                    <p v-if="errors.email" class="error">{{ $t('resellers.apply.form.error') }}</p>
                    <p v-else class="error"></p>
                  </div>
                </div>
                <div class="partner-form-row2 partner-form-row-2">
                  <div class="partner-form-field2">
                    <label for="phone" class="partner-form-label2">{{ $t('resellers.apply.form.phone') }}</label>
                    <input type="tel" id="phone" name="phone" v-model="form.phone" class="partner-form-input2" />
                    <p v-if="errors.phone" class="error">{{ $t('resellers.apply.form.error') }}</p>
                    <p v-else class="error"></p>
                  </div>
                  <div class="partner-form-field2">
                    <label for="businessType" class="partner-form-label2">{{ $t('resellers.apply.form.companyType') }}</label>
                    <select id="businessType" name="businessType" v-model="form.companyType" class="partner-form-input2">
                      <option value="cnc-dealer">{{ $t('resellers.apply.form.ctOption[0]') }}</option>
                      <option value="software-reseller">{{ $t('resellers.apply.form.ctOption[1]') }}</option>
                      <option value="interior-consultant">{{ $t('resellers.apply.form.ctOption[2]') }}</option>
                      <option value="technical-distributor">{{ $t('resellers.apply.form.ctOption[3]') }}</option>
                      <option value="system-integrator">{{ $t('resellers.apply.form.ctOption[4]') }}</option>
                      <option value="other">{{ $t('resellers.apply.form.ctOption[5]') }}</option>
                    </select>
                    <p v-if="errors.companyType" class="error">{{ $t('resellers.apply.form.error') }}</p>
                    <p v-else class="error"></p>
                  </div>
                </div>
                <div class="partner-form-row2 partner-form-row-2">
                  <div class="partner-form-field2">
                    <label for="territory" class="partner-form-label2">{{ $t('resellers.apply.form.workArea') }}</label>
                    <input type="text" id="territory" name="territory" :placeholder="$t('resellers.apply.form.waPlaceholder')" v-model="form.workArea" class="partner-form-input2"/>
                    <p v-if="errors.workArea" class="error">{{ $t('resellers.apply.form.error') }}</p>
                    <p v-else class="error"></p>
                  </div>
                  <div class="partner-form-field2">
                    <label for="tierInterest" class="partner-form-label2">{{ $t('resellers.apply.form.desiredTier') }}</label>
                    <select id="tierInterest" name="tierInterest" v-model="form.desiredTier" class="partner-form-input2">
                      <option value="silver">{{ $t('resellers.apply.form.waOption[0]') }}</option>
                      <option value="gold">{{ $t('resellers.apply.form.waOption[1]') }}</option>
                      <option value="platinum">{{ $t('resellers.apply.form.waOption[2]') }}</option>
                    </select>
                  </div>
                </div>
                <div class="partner-form-row2">
                  <div class="partner-form-field2">
                    <label for="portfolio" class="partner-form-label2">{{ $t('resellers.apply.form.portfolio') }}</label>
                    <textarea id="portfolio" name="portfolio" rows="3" :placeholder="$t('resellers.apply.form.cPlaceholder')" v-model="form.portfolio" class="partner-form-textarea2"></textarea>
                  </div>
                </div>
                <div class="partner-form-row2">
                  <div class="partner-form-field2">
                    <label for="message" class="partner-form-label2">{{ $t('resellers.apply.form.message') }}</label>
                    <textarea id="message" name="message" rows="4" :placeholder="$t('resellers.apply.form.mPlaceholder')" v-model="form.message" class="partner-form-textarea2"></textarea>
                  </div>
                </div>
                <button name="button w5cow00d4" type="submit" class="btn partner-form-submit2 btn-lg btn-primary">{{ $t('resellers.apply.form.submit') }}</button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <section class="partner-contact">
        <div class="section-content">
          <div class="partner-contact-container2">
            <div class="partner-contact-content">
              <h2 class="partner-contact-title2">{{ $t('resellers.contact.title') }}</h2>
              <p class="partner-contact-text">{{ $t('resellers.contact.text') }}</p>
            </div>
            <div class="partner-contact-methods2">
              <a href="mailto:info@vlecad.com">
                <div class="partner-contact-method2">
                  <div class="partner-contact-method-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                      </g>
                    </svg>
                  </div>
                  <div class="partner-contact-method-info">
                    <div class="partner-contact-method-label">
                      <span>{{ $t('resellers.contact.emailLabel') }}</span>
                    </div>
                    <div class="partner-contact-method-value">
                      <span>info@vlecad.com</span>
                    </div>
                  </div>
                </div>
              </a>
              <a href="tel:+3289819330">
                <div class="partner-contact-method2">
                  <div class="partner-contact-method-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <div class="partner-contact-method-info">
                    <div class="partner-contact-method-label">
                      <span>{{ $t('resellers.contact.phoneLabel') }}</span>
                    </div>
                    <div class="partner-contact-method-value">
                      <span>+32 (0)89 81 93 30</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
    <app-footer @show-cookies="showCookieBanner = true"></app-footer>
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";

import AppNavigation from "../components/navigation";
import AppFooter from "../components/footer";
import CookieBanner from "../components/cookiebanner.vue"
import axios from "axios";

export default {
  name: "Resellers",
  props: {},
  components: {
    AppNavigation,
    AppFooter,
    CookieBanner
  },
  setup() {
    // Vue 3 migration: move metaInfo into useHead.
    useHead({
      title: "Resellers - KORPUS by VLECAD®",
      meta: [
        {
          name: "description",
          content: "Resellers for KORPUS by VLECAD®: CAD/CAM software that thinks like a craftsman for interior builders and cabinet shops.",
        },
        {
          property: "og:title",
          content: "Resellers - KORPUS by VLECAD®",
        },
        {
          property: "og:description",
          content: "Resellers for KORPUS by VLECAD®: CAD/CAM software that thinks like a craftsman for interior builders and cabinet shops.",
        },
        {
          property: "og:image",
          content:
            "https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/ebedf48f-c2b5-4ca6-808d-9d940905bddf/993061ae-1787-4b73-9fda-47262adc60d9?org_if_sml=1&force_format=original",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://hospitable-imperfect-heron-qlicxu.teleporthq.app/resellers",
        },
      ],
    });
  },
  data() {
    return {
      baseURL: "https://my.vlecad.be/",
      showCookieBanner: false,
      form: {
        contact: '',
        email: '',
        company: '',
        phone: '',
        companyType: '',
        workArea: '',
        desiredTier: false,
        portfolio: '',
        message: ''
      },
      error: false,
      errors: {
        company: false,
        contact: false,
        email: false,
        phone: false,
        companyType: false,
        workArea: false,
      }
    };
  },
  methods: {
    handleSubmit() {
      console.log("handleSubmit called");
      console.log("form: " + JSON.stringify(this.form));

      this.error = false;
      this.errors.company = false;
      this.errors.contact = false;
      this.errors.email = false;
      this.errors.phone = false;
      this.errors.companyType = false;
      this.errors.workArea = false;
      if(this.form.company === "") {
        this.errors.company = true;
        return;
      }
      if(this.form.contact === "") {
        this.errors.contact = true;
        return;
      }
      if(this.form.email === "") {
        this.errors.email = true;
        return;
      }
      if(this.form.phone === "") {
        this.errors.phone = true;
        return;
      }
      if(this.form.companyType === "") {
        this.errors.companyType = true;
        return;
      }
      if(this.form.workArea === "") {
        this.errors.workArea = true;
        return;
      }

      axios.post(this.baseURL + "api/mail/sendMailResellers.php", this.form)
      .then((res) => {
        console.log(JSON.stringify(res.data));
      })
      .catch((err) => {
        console.log("error sendMailResellers: " + err);
      });

      console.log('Formulier verzonden:', this.form);
      alert('Bedankt! We nemen zo snel mogelijk contact met je op.');

      return false; // Zorgt ervoor dat de pagina niet opnieuw wordt geladen
    },
    handleConsent(consent) {
      console.log('Opgeslagen voorkeuren:', consent)
    }    
  }
};
</script>

<style>
@keyframes badge-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}
@keyframes scroll-pulse {
  0%,
  100% {
    opacity: 0.3;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(8px);
  }
}
@keyframes pulse-ring {
  0% {
    opacity: 0.8;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.3);
  }
}
* {
  transition: background-color 0.3s var(--animation-curve-primary), border-color 0.3s var(--animation-curve-primary), color 0.3s var(--animation-curve-primary);
}
</style>

<style scoped>
.resellers-container1 {
  width: 100%;
  display: block;
  min-height: 100vh;
}

.resellers-container2 {
  display: none;
}

.resellers-container3 {
  display: contents;
}

.resellers-container4 {
  display: none;
}

.resellers-container5 {
  display: contents;
}

.resellers-container6 {
  display: none;
}

.resellers-container7 {
  display: contents;
}

.resellers-text104 {
  color: #ffffff;
}

.resellers-thq-partner-hero-metrics-elm {
  display: none;
}

.resellers-thq-partner-why-card-elm3 {
  display: none;
}

.resellers-text142 {
  font-weight: 700;
}

.resellers-text153 {
  font-weight: 700;
}

.resellers-li38 {
  display: none;
}

.resellers-thq-partner-success-elm {
  display: none;
}

.resellers-thq-section-content-elm5 {
  display: none;
}

.resellers-thq-partner-resources-elm {
  display: none;
}

.resellers-container8 {
  display: none;
}

.resellers-container9 {
  display: contents;
}
</style>
